// extracted by mini-css-extract-plugin
module.exports = {"root":"AdminPanel_root__HB691","slidein":"AdminPanel_slidein__J9vto","layout":"AdminPanel_layout__sd8Bz","closeBtn":"AdminPanel_closeBtn__LZPyo"};